/* eslint-disable react/jsx-props-no-spreading */
import { useState } from 'react'
import PropTypes from 'prop-types'

import { SecondaryButton, InfoButton } from 'components/buttons'
import * as BLConstants from 'shared/constants'

import * as api from 'store/api'
import { parseErrorMessage } from 'lib/api-utils'

const AddToCartButton = ({
  buttonStyle,
  disabled,
  productId,
  quantity,
  useInfoButtonStyle,
  style,
  onSuccess,
}) => {
  const [added, setAdded] = useState(false)
  const [addingItemToCart, setAddingItemToCart] = useState(false)

  const text = added ? '✓ Added!' : 'Add to Cart'

  const handleClick = (e) => {
    e.preventDefault()
    setAddingItemToCart(true)
    api
      .addCartItem({ productId, quantity })
      .then((resp) => {
        setAdded(true)
        onSuccess(productId, quantity)
        PubSub.publish(BLConstants.UPDATE_CART_SUMMARY, {
          animateBadge: true,
          showCartDropdown: true,
        })
      })
      .catch((resp) => {
        PubSub.publish(BLConstants.FLASH_MESSAGE, {
          message: parseErrorMessage(resp),
          variant: 'danger',
        })
      })
      .finally((resp) => setAddingItemToCart(false))
  }

  return useInfoButtonStyle ? (
    <InfoButton
      block
      disabled={disabled}
      {...buttonStyle}
      onClick={handleClick}
      submitting={addingItemToCart}
      style={style}
    >
      {text}
    </InfoButton>
  ) : (
    <SecondaryButton
      block
      {...buttonStyle}
      onClick={handleClick}
      submitting={addingItemToCart}
      style={style}
    >
      {text}
    </SecondaryButton>
  )
}

AddToCartButton.propTypes = {
  buttonStyle: PropTypes.object,
  disabled: PropTypes.bool,
  productId: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  useInfoButtonStyle: PropTypes.bool,
  onSuccess: PropTypes.func,
}

AddToCartButton.defaultProps = {
  buttonStyle: {},
  disabled: false,
  useInfoButtonStyle: false,
  onSuccess: () => {},
}

export default AddToCartButton
